import styles from './style.postcss';

import React from 'react';
import classnames from 'classnames';
import { Icon, testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';

const ExpansionButton = (props) => {
  const { className, isExpand, onExpansionButtonClick } = props;
  const expandDescription = isExpand ? 'VIEW LESS' : 'VIEW MORE';
  const classes = classnames(className,
    styles.ExpansionButton,
    {
      [styles.__expanded]: isExpand,
      [testClass('expanded')]: isExpand,
      [testClass('collapsed')]: ! isExpand,
    });

  return <div className={classes} onClick={onExpansionButtonClick}>
    {expandDescription}
    <Icon id="chevron-small-down" className={styles.ExpansionButton_arrow} />
  </div>;
};

ExpansionButton.propTypes = {
  className: PropTypes.string,
  isExpand: PropTypes.bool.isRequired,
  onExpansionButtonClick: PropTypes.func.isRequired,
};

export default ExpansionButton;



// WEBPACK FOOTER //
// ./components/ExpansionButton/index.jsx